// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"Dimmer_Overlay__H8sqy"};